import { CartItemsComponent } from '@theme/component-cart-items';

(() => {
  if (window.__circCartDrawerExtrasBound) return;
  window.__circCartDrawerExtrasBound = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-circ-cart-add-variant]');
    if (!button || button.disabled || window.__circCartDrawerAddPending) return;

    const card = button.closest('[data-circ-cart-upgrade]');
    const error = card?.querySelector('[data-circ-cart-error]');
    const variantId = Number(button.dataset.circCartAddVariant);
    const expectedQuantity = Number(button.dataset.expectedQuantity);
    let addCommitted = false;
    window.__circCartDrawerAddPending = true;
    button.disabled = true;
    if (error) {
      error.hidden = true;
      error.textContent = '';
    }

    try {
      // Finish any already-started native quantity changes, then confirm that this
      // offer still matches the cart before mutating it.
      await Promise.allSettled(CartItemsComponent.pendingQuantityUpdates);
      const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });
      if (!cartResponse.ok) throw new Error('Der Warenkorb konnte nicht geprüft werden. Bitte versuche es erneut.');
      const cart = await cartResponse.json();
      const variantLines = (cart.items || []).filter((item) => Number(item.variant_id) === variantId);
      const currentQuantity = variantLines.reduce((total, item) => total + Number(item.quantity || 0), 0);
      if (variantLines.length !== 1 || currentQuantity !== expectedQuantity) {
        throw new Error('Dein Warenkorb hat sich geändert. Bitte prüfe das Angebot erneut.');
      }
      if (!button.isConnected) return;

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: ['cart-drawer-section'],
          sections_url: `${window.location.pathname}${window.location.search}`,
        }),
      });
      const result = await response.json();
      if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Das Produkt konnte nicht hinzugefügt werden.');
      addCommitted = true;

      const refreshedCartResponse = await fetch(`${window.Shopify.routes.root}cart.js`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });
      if (!refreshedCartResponse.ok) throw new Error('Das Produkt wurde hinzugefügt. Bitte lade die Seite neu, um den Warenkorb zu aktualisieren.');
      const refreshedCart = await refreshedCartResponse.json();
      const updateEvent = new CustomEvent('shopify:cart:lines-update', {
        bubbles: true,
        detail: { itemCount: refreshedCart.item_count || 0, sections: result.sections },
      });
      updateEvent.promise = Promise.resolve({ cart: { totalQuantity: refreshedCart.item_count || 0 }, detail: updateEvent.detail });
      document.dispatchEvent(updateEvent);

      const drawer = document.querySelector('theme-drawer#cart-drawer');
      if (drawer && !drawer.isOpen) drawer.open();
    } catch (requestError) {
      console.error('[Circ cart drawer] Upgrade add failed:', requestError);
      if (error) {
        error.textContent = requestError.message || 'Bitte versuche es erneut.';
        error.hidden = false;
      }
    } finally {
      window.__circCartDrawerAddPending = false;
      // If Shopify accepted the add but the refresh failed, keep this control disabled
      // so a shopper cannot accidentally add the same item twice.
      if (button.isConnected && !addCommitted) button.disabled = false;
    }
  });
})();
